import type { TTaskListItem } from '@modules/projects/tasks/types';

// WARNING Mirrored in FE/BE - keep in sync. Counterpart: backend/src/organizations/schemas/configs/organizationMock.schema.ts
export enum EStageStatus {
  COMPLETED = 'COMPLETED',
  CURRENT = 'CURRENT',
  UPCOMING = 'UPCOMING',
  CANCELLED = 'CANCELLED',
}

export enum EGateDecision {
  ACCEPT = 'ACCEPT',
  REWORK = 'REWORK',
  CANCEL = 'CANCEL',
}

export type TStageGateMock = {
  title: string;
  description?: string;
  checklist?: string[];
  gatekeeper?: string;
};

export type TStageMock = {
  title: string;
  status: EStageStatus;
  startInDays?: number;
  endInDays?: number;
  gate?: TStageGateMock;
  tasks?: string[];
};

export type TProjectStagesMock = {
  project: string;
  stages: TStageMock[];
};

export type TGateState = { checked: number[]; decision?: EGateDecision };

export type TStage = Omit<TStageMock, 'startInDays' | 'endInDays'> & {
  index: number;
  startDate?: string;
  endDate?: string;
  gateState?: TGateState;
};

/** Without a stage, the tasks no stage lists. */
export type TStageSection = { stage?: TStage; tasks: TTaskListItem[] };
